import React from 'react';

import { Heading } from '@auspost/postmaster-react';

import { Milestone } from 'models/shipments';
import { trackInteraction } from 'store/analytics/analytics.thunks';
import { useAppDispatch } from 'store/store';
import { showEdd } from 'utils/milestone.utils';

import { useCurrentArticle } from '../hooks/shipment.hooks';
import ConsignmentSwitcher from './ConsignmentSwitcher/ConsignmentSwitcher';
import Edd from './Edd/Edd';
import JourneyView from './JourneyView/JourneyView';
import OverviewView from './OverviewView/OverviewView';
import TrackingTabSwitcher, { TrackingTabSwitcherOptions } from './TrackingTabSwitcher/TrackingTabSwitcher';
import { TRACKING_PANEL_TEST_ID } from './TrackingPanel.test-ids';

import styles from './TrackingPanel.module.scss';

const TrackingPanel: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<TrackingTabSwitcherOptions | string>(
    TrackingTabSwitcherOptions.OVERVIEW
  );
  const dispatch = useAppDispatch();
  const latestEventMilestone = useCurrentArticle()?.events?.[0]?.milestone ?? Milestone.PENDING;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setActiveTab(e.target.value);
    dispatch(trackInteraction(e.target.value));
  };

  return (
    <div className={styles.trackingPanelWrapper} data-testid={TRACKING_PANEL_TEST_ID}>
      <div className={styles.headerSection}>
        <Heading level='h3' className={styles.header} id='trackingPanelHeading'>
          Tracking
        </Heading>
        <TrackingTabSwitcher activeTab={activeTab} onChange={handleChange} />
      </div>
      <ConsignmentSwitcher />
      {activeTab === TrackingTabSwitcherOptions.OVERVIEW ? <OverviewView /> : <JourneyView />}
      {showEdd(latestEventMilestone) && <Edd />}
    </div>
  );
};

export default TrackingPanel;
